import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { formatMoeda, getUuidV4, goToFocus, handleNumberOnly, validarCPFCNPJ } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ContratanteInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { addContratante, removeContratante, removeContratanteTodos } from "../../../features/manifestoSlice";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: ContratanteInterface = {
    id: 0,
    xNome: '',
    documento: '',
    idestrangeiro: false,
    infContrato: false,
    nroContrato: '',
    vContratoGlobal: 0
}

export default function Contratante() {
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lista = useSelector(
        (state: RootState) => state.manifesto.manifesto.modal_rodoviario?.infANTT.infContratante
    );
    const [form, setForm] = useState<ContratanteInterface>(initialForm)
    const documentoRef = useRef<HTMLInputElement>(null);
    const nroContratoRef = useRef<HTMLInputElement>(null);
    const vContratoRef = useRef<HTMLInputElement>(null);
    const nomeRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const validarPreenchimento = () => {
        if (form.documento === "") {
            goToFocus(documentoRef);
            alertModal('Informe o CPF/CNPJ.');
            return false;
        }

        if (!form.idestrangeiro) {
            if (!validarCPFCNPJ(form.documento)) {
                goToFocus(documentoRef);
                alertModal('CPF/CNPJ inválido.');
                return false;
            }
        }

        if (form.infContrato) {
            if (form.nroContrato === "" || form.nroContrato === "0") {
                goToFocus(nroContratoRef)
                alertModal('Informe o número do contrato.');
                return false;
            }

            if (form.vContratoGlobal === 0) {
                goToFocus(vContratoRef);
                alertModal('Informe o valor do contrato.');
                return false;
            }
        }

        if (lista.find((item: ContratanteInterface) => item.documento === form.documento)) {
            goToFocus(documentoRef);
            alertModal('Contratante com esse CPF/CNPJ já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addContratante({
                ...form,
                id: getUuidV4()
            }));
            setForm(initialForm);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação",
        })

        if (confirmed) {
            dispatch(removeContratante(value.id));
            setForm(initialForm);
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação",
            })
            if (confirmed) {
                goToFocus(nomeRef);
                dispatch(removeContratanteTodos());
            }
        }
    }

    return (<>
        <Row className=" g-2 mb-3">
            <Col md={4} >
                <Form.Group controlId="contratante-xnome">
                    <Form.Label>Nome (opcional)</Form.Label>
                    <Form.Control placeholder="" name="xNome" ref={nomeRef}
                        maxLength={30} type="text" onChange={handleChange} value={form.xNome} />
                </Form.Group>
            </Col>
            <Col md={2} >
                <Form.Group controlId="documento" >
                    <Form.Label>{!form.idestrangeiro ? 'CPF/CNPJ' : 'Identificador Contratante'}</Form.Label>
                    <Form.Control onKeyUp={handleNumberOnly} name="documento" value={form.documento} ref={documentoRef}
                        maxLength={!form.idestrangeiro ? 14 : 20} type="text" onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end" >
                <Form.Group >

                    <Form.Switch type="switch" checked={form.idestrangeiro} id="active"
                        name="active" label="Estrangeiro?"
                        onChange={(e) => setForm({ ...form, idestrangeiro: e.target.checked })}
                    />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex  align-items-end">
                <Form.Group >
                    <Button variant="primary" onClick={handleAdd}><FontAwesomeIcon icon={faPlus} />  Adicionar</Button>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={'auto'} className="d-flex align-items-center ">
                <Form.Group controlId="active">
                    <Form.Switch type="switch" onChange={(e) => {
                        setForm({
                            ...form,
                            nroContrato: !e.target.checked ? '' : form.nroContrato,
                            vContratoGlobal: !e.target.checked ? 0 : form.vContratoGlobal,
                            infContrato: e.target.checked

                        })
                    }}
                        checked={form.infContrato}
                        name="active" label="Indica dados do contrato?" />
                </Form.Group>
            </Col>
        </Row>

        <Row className="mb-3 g-2">
            {form.infContrato && (<>
                <Col md={2}>
                    <Form.Group controlId="nroContrato">
                        <Form.Label>Nro. Contrato</Form.Label>
                        <Form.Control name="nroContrato" type="text" maxLength={20} ref={nroContratoRef}
                            onKeyUp={handleNumberOnly} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={2}>
                    <Form.Group controlId="vContratoGlobal">
                        <Form.Label>Vlr. Contrato Global</Form.Label>
                        <Form.Control type="number" value={form.vContratoGlobal} ref={vContratoRef}
                            name="vContratoGlobal" maxLength={15}
                            onChange={(e) => {
                                setForm({
                                    ...form,
                                    vContratoGlobal: parseFloat(
                                        e.target.value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d+/, "$1")
                                    )
                                })
                            }}
                        />
                    </Form.Group>
                </Col>
            </>
            )}

        </Row>

        <JTable>
            <JTHead >
                <tr>
                    <th rowSpan={2} className="text-center align-middle" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th className="text-center align-middle" rowSpan={2}>Nome</th>
                    <th className="text-center align-middle" rowSpan={2}>CPF/CNPJ/Id. Estrangeiro</th>
                    <th colSpan={2} className="text-center"> Dados do contrato</th>
                </tr>
                <tr>
                    <th className="text-center" >Nro. Contrato</th>
                    <th className="text-center" >Vlr. Contrato Global</th>
                </tr>
            </JTHead>

            <JTBody>
                {lista?.map((item: ContratanteInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.documento })} />
                        </td>
                        <td className="text-center">{item.xNome}</td>
                        <td className="text-center">{item.documento}</td>
                        <td className="text-center">{item.nroContrato}</td>
                        <td className="text-center">{formatMoeda(item.vContratoGlobal ?? 0)}
                        </td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}